import * as React from 'react';
import classNames from 'classnames';
import {Icon} from '@iconify/react';

import './Avatar.sass';


export type TAvatarType = 'user' | 'room';

export const Avatar: React.FC<{
    uri?: string;
    size?: number;
    type?: TAvatarType;
    selected?: boolean;
    online?: boolean;
    style?: React.CSSProperties;
}> = ({size = 32, type = 'user', selected = false, online, style, uri}) => {
    const [imageLoaded, setImageLoaded] = React.useState<boolean>(false);
    const className = classNames(
        'mvc-avatar',
        {
            selected: selected,
            online: online === true,
            offline: online === false,
        },
        type,
    );

    const isChat: boolean = type === 'room';
    const iconId: string = isChat ? 'jam:messages-f' : 'fa-solid:user';
    const iconSize: number = isChat ? (size / 4) * 3 : (size / 4) * 3.5;
    return (
        <div
            className={className}
            style={{
                width: size,
                height: size,
                ...style,
            }}>

            {uri &&
            <img
              hidden={!imageLoaded}
              src={uri}
              alt={''}
              onError={() => setImageLoaded(false)}
              onLoad={() => setImageLoaded(true)}/>}


            {!imageLoaded && <Icon
              icon={iconId}
              style={{
                  opacity: !uri && imageLoaded ? 0 : 1,
                  paddingTop: isChat ? 0 : size > 24 ? 6 : 4,
              }}
              className={'mvc-avatar-icon'}
              height={iconSize}
            />}
        </div>
    );
};
